import { render, staticRenderFns } from "./CResult.vue?vue&type=template&id=a739dc34&scoped=true&"
import script from "./CResult.vue?vue&type=script&lang=js&"
export * from "./CResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a739dc34",
  null
  
)

export default component.exports